module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VueCtkDateTimePicker', {
    staticClass: " input-group force-white",
    attrs: {
      "disabled": _vm.isDisabled,
      "input-size": "sm",
      "format": "YYYY/MM/DD HH:mm",
      "output-format": "YYYY/MM/DD HH:mm",
      "formatted": "YYYY/MM/DD HH:mm",
      "color": "#3b89cb",
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "label": null,
      "no-label": true,
      "inline": false,
      "locale": "ja-jp",
      "button-now-translation": "今",
      "no-value-to-custom-elem": true
    },
    model: {
      value: (_vm.localModel),
      callback: function($$v) {
        _vm.localModel = $$v
      },
      expression: "localModel"
    }
  }, [_c('span', {
    staticClass: "calendar-test input-group-addon btn",
    style: (_vm.inputStyle + 'padding: 0px 8px !important'),
    attrs: {
      "disabled": _vm.isDisabled
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localModel),
      expression: "localModel"
    }],
    staticClass: "form-control form-control",
    style: (_vm.inputStyle + 'height: 25px !important; marging: 2px; border-radius: 0px'),
    attrs: {
      "disabled": _vm.isDisabled,
      "type": "text"
    },
    domProps: {
      "value": (_vm.localModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localModel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "calendar-test input-group-addon btn",
    style: (_vm.inputStyle + 'padding: 0px 8px !important'),
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.clearCalendar
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove"
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f98e296","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dp/Datetimepicker2.vue
// module id = 933
// module chunks = 0